import { css, SerializedStyles } from '@emotion/react';

export const polygonStyled = (
  starType: number,
  fillStar: string,
  fillBackground: string,
  strokeColor: string,
  strokeWidth: number,
): SerializedStyles => css`
  fill: ${starType === 4 ? fillStar : fillBackground};
  stroke: ${strokeColor};
  stroke-width: ${strokeWidth}px;
`;

export const star = (size = 20) => css`
  display: inline-block;
  height: ${size}px;
  width: ${size}px;
`;
